import React from 'react';
import './DetailItem.scss';

export interface DetailItemProps {
  icon?: React.ReactNode;
  label?: string;
  value: React.ReactNode;
  className?: string;
  suffix?: React.ReactNode;
}

export const DetailItem: React.FC<DetailItemProps> = ({
  icon,
  label,
  value,
  className = '',
  suffix,
}) => {
  return (
    <div className={`detail-item ${className}`}>
      {icon && <span className="detail-item__icon">{icon}</span>}
      {label && <span className="detail-item__label">{label}</span>}
      <span className="detail-item__value">{value}</span>
      {suffix && <span className="detail-item__suffix">{suffix}</span>}
    </div>
  );
};

// Grid wrapper for detail items
export interface DetailGridProps {
  columns?: 1 | 2 | 3 | 4;
  children: React.ReactNode;
  className?: string;
}

export const DetailGrid: React.FC<DetailGridProps> = ({
  columns = 2,
  children,
  className = '',
}) => {
  return (
    <div className={`detail-grid detail-grid--cols-${columns} ${className}`}>
      {children}
    </div>
  );
};

